module.exports = __webpack_public_path__ + "static/media/postcard7.332f74e2.jpg";